export const EMPLOYER_USER_INVITATION_VERIFY_ROUTES = {
  get: '/employer-users/invitations/verify/{code}',
};

export const EMPLOYER_USER_INVITATION_ELIGIBILITY_ROUTES = {
  get: '/employer-users/invitations/eligibility/{code}',
};

export const EMPLOYER_USER_FROM_INVITATION_ROUTES = {
  post: '/employer-users/from-invitation',
};

export const EMPLOYER_USER_INVITATIONS_FOR_EMPLOYER_ROUTES = {
  post: '/employer-users/employer/{employer_id}/invitations',
  get: '/employer-users/employer/{employer_id}/invitations',
  delete: '/employer-users/employer/{employer_id}/invitations/{invitation_id}',
};

export const EMPLOYER_USER_INVITATION_RESEND_ROUTES = {
  post: '/employer-users/employer/{employer_id}/invitations/{invitation_id}/resend',
};
